import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ProductdevelopmentService { 

    constructor(private http: HttpClient) { }

    getproductdevelopmentService() {
        return this.http.get<any[]>(`${environment.apiUrl}get_product_development`);
    }    	    
}
